(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('../core/gift-cart-policy.js'));
  } else {
    root.SwellHolidayGiftsFactory = factory(root.SwellGiftCartPolicy);
    if (root.SWELL_HOLIDAY_GIFT_CONFIG && !root.SwellHolidayGifts) {
      root.SwellHolidayGifts = root.SwellHolidayGiftsFactory.installBrowser(root, root.SWELL_HOLIDAY_GIFT_CONFIG);
    }
  }
}(typeof globalThis !== 'undefined' ? globalThis : this, function (policy) {
  'use strict';
  if (!policy || typeof policy.planGiftCart !== 'function') throw new Error('SwellGiftCartPolicy is required');
  var VARIANT = '67679733973305';
  var LOCK = 'swell-trial-cart-integrity-v2';
  var STORAGE = 'swell:holiday-gift:v1:';
  var OPERATION = '_swell_holiday_gift_operation';
  function isGift(line) { return String(line.variant_id) === VARIANT; }
  function isOneTime(line) { return !line.selling_plan_allocation && !line.selling_plan; }
  function tokenOf(cart) {
    if (!cart || !Array.isArray(cart.items) || typeof cart.token !== 'string' || !cart.token) throw new Error('A complete cart is required');
    return cart.token;
  }
  function createController(config, io) {
    config = config || {};
    if (!io || typeof io.readCart !== 'function' || typeof io.writeCart !== 'function' || typeof io.withLock !== 'function') {
      throw new Error('Cart read, write and shared lock adapters are required');
    }
    var pending = null, disposed = false, last = null, lastCart = null, rerun = false;
    function enabled() { return config.enabled === true && config.backendReady === true && config.legacyBundleHelperRemoved === true; }
    function load(cart) {
      var token = tokenOf(cart), value;
      try { value = JSON.parse(io.storage.getItem(STORAGE + token)); } catch (_) { value = null; }
      return value && value.version === 1 && value.token === token ? value
        : { version: 1, token: token, optOut: false, confirmedGiftQuantity: 0, attempt: null, rejected: null };
    }
    function save(value) { io.storage.setItem(STORAGE + value.token, JSON.stringify(value)); }
    function publish(result, cart, mutated) {
      last = result; lastCart = cart || lastCart;
      if (typeof io.onState === 'function') io.onState(result, lastCart);
      if ((mutated || result.status === 'NO_CHANGE') && typeof io.publishCart === 'function') io.publishCart(cart);
      return result;
    }
    function evaluate(cart, state, stock) {
      return policy.planGiftCart(cart, { allowedNewPlanIds: config.allowedNewPlanIds || [], giftStock: stock, optOut: state.optOut === true, paidGiftExtras:config.paidGiftExtras===true, selectedGiftQuantity:state.selectedGiftQuantity });
    }
    function recovered(cart, attempt) {
      if (attempt.type === 'add') {
        return cart.items.some(function (line) { return isGift(line) && isOneTime(line) && line.properties && line.properties[OPERATION] === attempt.operationId; });
      }
      var line = cart.items.find(function (item) { return item.key === attempt.key; });
      return attempt.quantity === 0 ? !line : !!line && isGift(line) && line.quantity === attempt.quantity;
    }
    function failure(reason, result, error) {
      return Object.assign({}, result || {}, { status: 'DEFERRED', deferredReason: reason, confirmedGiftQuantity: 0,
        error: error ? String(error.message || error) : null, requiresFreshSnapshot: true });
    }
    async function run(options) {
      options = options || {};
      if (!enabled() || disposed) return publish({ status: 'DISABLED', confirmedGiftQuantity: 0 }, null, false);
      return io.withLock(async function () {
        var mutated = false, cart, state, result;
        for (var cycle = 0; cycle < 8; cycle += 1) {
          cart = await io.readCart(); tokenOf(cart); state = load(cart);
          var nativeMarket = config.nativeMarketCurrencies === true && typeof cart.currency === 'string' && /^[A-Z]{3}$/.test(cart.currency);
          if (!nativeMarket && (config.allowedCurrencies || ['USD']).indexOf(cart.currency) === -1) {
            return publish(failure('MARKET_NOT_ENABLED'), cart, mutated);
          }
          if (cycle === 0 && typeof options.optOut === 'boolean') { state.optOut = options.optOut; state.selectedGiftQuantity=options.optOut?0:null; state.rejected = null; save(state); }
          result = evaluate(cart, state, null);
          var recoveringOwnMutation = !!state.attempt;
          if (state.attempt) {
            if (recovered(cart, state.attempt) || state.attempt.status === 'confirmed') {
              state.attempt = null; save(state);
            } else if (state.optOut || result.entitledGiftQuantity === 0) {
              state.attempt = null; save(state);
            } else {
              return publish(failure('UNCONFIRMED_CART_MUTATION', result), cart, mutated);
            }
          }
          if(!mutated && !recoveringOwnMutation && !options.restore && Number.isSafeInteger(state.lastBagQuantity) && state.lastBagQuantity!==result.currentGiftQuantity){state.selectedGiftQuantity=result.currentGiftQuantity;state.optOut=result.currentGiftQuantity===0;save(state);result=evaluate(cart,state,null);}
          if(config.paidGiftExtras===true && state.lastBagQuantity===undefined && result.currentGiftQuantity>result.entitledGiftQuantity){state.selectedGiftQuantity=result.currentGiftQuantity;save(state);result=evaluate(cart,state,null);}
          if (!mutated && !recoveringOwnMutation && state.confirmedGiftQuantity > 0 && result.currentGiftQuantity === 0 && result.entitledGiftQuantity > 0 && !options.restore) {
            state.optOut = true; state.rejected = null; save(state); result = evaluate(cart, state, null);
          }
          var stock = null;
          if (!state.optOut && (result.entitledGiftQuantity > 0 || config.paidGiftExtras===true && (state.selectedGiftQuantity>0 || result.currentGiftQuantity>0))) {
            try { stock = await io.readStock(); } catch (_) { stock = null; }
          }
          result = evaluate(cart, state, stock);
          if (result.status === 'DEFERRED') return publish(result, cart, mutated);
          if (result.status === 'NO_CHANGE') {
            if (!policy.giftPriceEvidence(cart,result.entitledGiftQuantity,config.paidGiftExtras===true)) {
              return publish(failure('GIFT_PRICE_NOT_CONFIRMED_FREE', result), cart, mutated);
            }
            state.confirmedGiftQuantity = result.confirmedGiftQuantity; state.lastBagQuantity=result.currentGiftQuantity; state.rejected = null; save(state);
            return publish(result, cart, mutated);
          }
          if (state.rejected && state.rejected.fingerprint === result.snapshotFingerprint && state.rejected.stock === stock) {
            return publish(failure('NATIVE_CART_REJECTED_GIFT', result), cart, mutated);
          }
          var fresh = await io.readCart();
          if (tokenOf(fresh) !== tokenOf(cart) || evaluate(fresh, state, stock).snapshotFingerprint !== result.snapshotFingerprint) continue;
          cart = fresh;
          var action = result.actions[0], body, attempt;
          if (!action) throw new Error('Gift change plan has no action');
          if (action.type === 'change') {
            var target = cart.items.find(function (line) { return line.key === action.key; });
            if (!target || !isGift(target)) throw new Error('Gift planner attempted to change another product');
            body = { id: action.key, quantity: action.quantity };
            attempt = { type: 'change', key: action.key, quantity: action.quantity, status: 'in_flight' };
          } else if (action.type === 'add' && String(action.variantId) === VARIANT) {
            var operationId = io.operationId();
            body = { items: [{ id: VARIANT, quantity: action.quantity, properties: { _swell_holiday_gift: 'v1' } }] };
            body.items[0].properties[OPERATION] = operationId;
            attempt = { type: 'add', operationId: operationId, quantity: action.quantity, status: 'in_flight' };
          } else { throw new Error('Unsupported gift action'); }
          attempt.snapshotFingerprint = result.snapshotFingerprint; attempt.planId = result.planId;
          state.attempt = attempt; save(state);
          try {
            await io.writeCart(action.type === 'add' ? 'cart/add.js' : 'cart/change.js', body);
            mutated = true; state.attempt.status = 'confirmed'; save(state);
          } catch (error) {
            if (error.definitive === true) {
              state.attempt = null;
              state.rejected = { fingerprint: result.snapshotFingerprint, stock: stock };
              save(state);
              return publish(failure('NATIVE_CART_REJECTED_GIFT', result, error), await io.readCart(), mutated);
            }
            state.attempt.status = 'unknown'; save(state);
            var observed = await io.readCart();
            if (!recovered(observed, state.attempt)) return publish(failure('UNCONFIRMED_CART_MUTATION', result, error), observed, mutated);
            mutated = true; state.attempt = null; save(state);
          }
        }
        return publish(failure('CART_CHANGED_DURING_RECONCILIATION', result), cart, mutated);
      });
    }
    function refresh(options) {
      if (pending) { rerun = true; return pending; }
      pending = (async function () {
        var result;
        for (var pass = 0; pass < 3; pass += 1) {
          rerun = false; result = await run(pass === 0 ? options : {});
          if (!rerun || disposed) return result;
        }
        return publish(failure('CART_CHANGED_DURING_RECONCILIATION', result), lastCart, false);
      }()).catch(function (error) {
        publish(failure('CART_REFRESH_FAILED', last, error), lastCart, false); throw error;
      }).finally(function () { pending = null; });
      return pending;
    }
    function setOptOut(value) {
      return Promise.resolve(pending).catch(function () {}).then(function () { return refresh({ optOut: value, restore: value === false }); });
    }
    return Object.freeze({
      refresh: refresh,
      customerChoice: function (cart) { return { optOut: load(cart).optOut === true }; },
      optOut: function () { return setOptOut(true); },
      restoreGift: function () { return setOptOut(false); },
      prepareCheckout: async function () {
        var result = await refresh();
        return { ready: result.status === 'NO_CHANGE' || result.status === 'DISABLED', result: result };
      },
      state: function () { return { pending: !!pending, result: last, cart: lastCart }; },
      disconnect: function () { disposed = true; }
    });
  }
  function normalizeStock(data) {
    if (!data || String(data.variantId || data.id) !== VARIANT) return null;
    if (data.available === false) return 0;
    if (data.inventoryPolicy === 'continue' || data.requiresShipping === false || data.tracked === false) return null;
    var quantity = data.availableQuantity === undefined ? data.inventory_quantity : data.availableQuantity;
    return Number.isSafeInteger(quantity) && quantity >= 0 ? quantity : null;
  }
  function installBrowser(win, config) {
    if (!win.document || win.SwellBundleSubscriptions || config.enabled !== true || config.backendReady !== true || config.legacyBundleHelperRemoved !== true) {
      return Object.freeze({ state: function () { return { result: { status: 'DISABLED', deferredReason: win.SwellBundleSubscriptions ? 'LEGACY_BUNDLE_HELPER_PRESENT' : 'RELEASE_NOT_ENABLED' } }; } });
    }
    var route = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/').replace(/\/?$/, '/');
    var timer, observer, disconnected = false, hooks = [], removers = [], lastPublished = '', stockPending = null;
    async function request(path, body) {
      var url = new URL(route + path, win.location.origin);
      if (url.origin !== win.location.origin) throw new Error('Cart requests must be same origin');
      if (body) url.searchParams.set('_swell_cart_writer', 'gift');
      var response = await win.fetch(url.href, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: Object.assign({ Accept: 'application/json' }, body ? { 'Content-Type': 'application/json' } : {}),
        body: body ? JSON.stringify(body) : undefined });
      var data;
      try { data = await response.json(); } catch (_) { throw new Error('Cart response could not be verified'); }
      if (!response.ok) {
        var error = new Error(data.description || data.message || 'Cart update could not be verified');
        error.definitive = [400, 401, 403, 404, 422].indexOf(response.status) !== -1; throw error;
      }
      return data;
    }
    async function fetchStock() {
      if (typeof config.readStock === 'function') return normalizeStock(await config.readStock());
      if (typeof config.stockSectionId === 'string' && /^[a-zA-Z0-9_-]+$/.test(config.stockSectionId)) {
        var sections = await request('?sections=' + encodeURIComponent(config.stockSectionId) + '&_swell_stock=' + Date.now());
        var html = sections[config.stockSectionId];
        if (typeof html !== 'string') return null;
        var doc = new win.DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('script[type="application/json"][data-swell-holiday-stock]');
        return node ? normalizeStock(JSON.parse(node.textContent)) : null;
      }
      if (typeof config.productHandle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(config.productHandle)) {
        var product = await request('products/' + encodeURIComponent(config.productHandle) + '.js');
        var variant = Array.isArray(product.variants) && product.variants.find(function (v) { return String(v.id) === VARIANT; });
        return normalizeStock(variant);
      }
      return null;
    }
    function stock() {
      if (!stockPending) stockPending = fetchStock().finally(function () { stockPending = null; });
      return stockPending;
    }
    var controller = createController(config, {
      readCart: function () { return request('cart.js'); }, writeCart: request, readStock: stock,
      storage: win.localStorage, operationId: function () { return win.crypto.randomUUID(); },
      withLock: function (fn) {
        if (win.SwellTrialCartIntegrity && typeof win.SwellTrialCartIntegrity.withLock === 'function') return win.SwellTrialCartIntegrity.withLock(fn);
        if (win.navigator.locks && typeof win.navigator.locks.request === 'function') return win.navigator.locks.request(LOCK, fn);
        throw new Error('Shared cart lock is unavailable');
      },
      onState: function (result) { win.document.dispatchEvent(new win.CustomEvent('swell:holiday-gift-state', { detail: result })); },
      publishCart: function (cart) {
        var signature = JSON.stringify([cart.token, cart.currency, cart.items, cart.discount_codes, cart.total_price]);
        if (signature === lastPublished) return;
        lastPublished = signature;
        if (typeof config.publishCart === 'function') config.publishCart(cart);
        else if (typeof win.SLIDECART_SET_CART === 'function') win.SLIDECART_SET_CART(cart);
        else if (typeof win.SLIDECART_UPDATE === 'function') win.SLIDECART_UPDATE();
        win.document.dispatchEvent(new win.CustomEvent('swell:holiday-gift-cart-confirmed', { detail: { cart: cart, result: controller.state().result } }));
      }
    });
    function schedule() {
      if (disconnected) return;
      win.clearTimeout(timer); timer = win.setTimeout(function () { controller.refresh().catch(function () {}); }, 180);
    }
    function listen(target, name, fn, capture) {
      target.addEventListener(name, fn, capture); removers.push(function () { target.removeEventListener(name, fn, capture); });
    }
    function installHooks() {
      ['SLIDECART_UPDATED', 'SLIDECART_OPENED', 'SLIDECART_ADDED_TO_CART'].forEach(function (name) {
        var previous = win[name];
        if (previous && previous._swellHolidayGiftHook) return;
        var wrapped = function () { try { return typeof previous === 'function' ? previous.apply(this, arguments) : undefined; } finally { schedule(); } };
        wrapped._swellHolidayGiftHook = true; hooks.push({ name: name, previous: previous, wrapped: wrapped }); win[name] = wrapped;
      });
    }
    function chooseGift(restore) {
      var task = restore ? controller.restoreGift() : controller.optOut();
      if (config.managedByRuntime !== true) return task;
      return task.finally(function () {
        if (!disconnected) win.document.dispatchEvent(new win.CustomEvent('swell:cart-updated', { detail: { source: 'gift-choice' } }));
      });
    }
    listen(win.document, 'click', function (event) {
      var target = event.target && event.target.closest && event.target.closest('[data-swell-gift-remove],[data-swell-gift-restore]');
      if (!target) return;
      event.preventDefault();
      chooseGift(target.hasAttribute('data-swell-gift-restore')).catch(function () {});
    }, false);
    if (config.managedByRuntime !== true) {
      ['cart:updated', 'cart:change', 'cart:refresh', 'swell:cart-updated', 'swell:coupon-settled', 'swell:bf30-cart-confirmed'].forEach(function (name) { listen(win.document, name, schedule, false); });
      listen(win, 'pageshow', schedule, false);
      listen(win, 'storage', function (event) { if (event.key && event.key.indexOf(STORAGE) === 0) schedule(); }, false);
      listen(win.document, 'visibilitychange', function () { if (win.document.visibilityState === 'visible') schedule(); }, false);
      listen(win, 'load', installHooks, false);
    }
    if (config.managedByRuntime !== true && typeof win.PerformanceObserver === 'function') {
      try {
        observer = new win.PerformanceObserver(function (list) {
          if (list.getEntries().some(function (entry) {
            var url = new URL(entry.name, win.location.href);
            return url.origin === win.location.origin && !['bf30', 'gift', 'coupon'].includes(url.searchParams.get('_swell_cart_writer')) && /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
          })) schedule();
        }); observer.observe({ type: 'resource', buffered: true });
      } catch (_) { observer = null; }
    }
    if (config.managedByRuntime !== true) { installHooks(); schedule(); }
    return Object.freeze({
      refresh: controller.refresh, optOut: function () { return chooseGift(false); }, restoreGift: function () { return chooseGift(true); },
      prepareCheckout: controller.prepareCheckout, readStock: stock, customerChoice: controller.customerChoice, state: controller.state,
      disconnect: function () {
        disconnected = true; win.clearTimeout(timer); if (observer) observer.disconnect();
        removers.forEach(function (remove) { remove(); });
        hooks.reverse().forEach(function (hook) { if (win[hook.name] === hook.wrapped) win[hook.name] = hook.previous; });
        controller.disconnect();
      }
    });
  }
  return Object.freeze({ createController: createController, installBrowser: installBrowser, normalizeStock: normalizeStock, giftVariantId: VARIANT, lockName: LOCK });
}));


